import Popup from 'reactjs-popup'
import './Popup.css'
import 'reactjs-popup/dist/index.css'

export default Popup;


// WEBPACK FOOTER //
// ./src/components/Popup/Popup.js